import { Haptics, ImpactStyle, NotificationType } from '@capacitor/haptics';
import { isNativeApp } from './nativeApp';

export const tapFeedback = async () => {
  if (!isNativeApp()) return;
  try {
    await Haptics.impact({ style: ImpactStyle.Medium });
  } catch {
    try { (navigator as any).vibrate?.(15); } catch { /* no-op */ }
  }
};

export const successFeedback = async () => {
  if (!isNativeApp()) return;
  try { await Haptics.notification({ type: NotificationType.Success }); } catch { /* no-op */ }
};

export const errorFeedback = async () => {
  if (!isNativeApp()) return;
  try { await Haptics.notification({ type: NotificationType.Error }); } catch { /* no-op */ }
};
